import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=2b481ca7&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./Autocomplete.vue?vue&type=style&index=0&id=2b481ca7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports